import React from "react";
import Reveal from "../components/ui/Reveal";
import SEO from "../components/seo/SEO";

export default function TermsOfServicePage() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="CampusGenie Terms and Conditions. Read our terms of use, account registration, and service guidelines."
        url="/terms"
      />

      <section className="legal-page-hero">
        <div className="container">
          <Reveal>
            <span className="eyebrow">Legal</span>
            <h1 className="heading-1" style={{ maxWidth: "20ch", margin: "0 auto 16px" }}>
              Terms of Service
            </h1>
            <p className="body-base" style={{ textAlign: "center", maxWidth: "520px", margin: "0 auto" }}>
              Effective: February 2010 · Last modified: October 2024
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section section-sm section-alt">
        <div className="container">
          <Reveal>
            <article className="legal-prose">
              <section>
                <h2 className="heading-4">Introduction</h2>
                <p className="body-base">
                  These Terms and Conditions govern your use of the CampusGenie platform. By using our services, you agree
                  to comply with these terms.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Account registration</h2>
                <h3 className="legal-prose-sub">Eligibility</h3>
                <p className="body-base">You must be at least 13 years old to create an account on CampusGenie.</p>
                <h3 className="legal-prose-sub">Account security</h3>
                <p className="body-base">
                  You are responsible for maintaining the confidentiality of your account information and for all activities
                  that occur under your account.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Use of the platform</h2>
                <h3 className="legal-prose-sub">Prohibited activities</h3>
                <p className="body-base">
                  You may not use the platform for any illegal or unauthorized purpose, including but not limited to
                  engaging in activities that harm the CampusGenie community.
                </p>
                <h3 className="legal-prose-sub">User content</h3>
                <p className="body-base">
                  You retain ownership of any content you post on the platform, but you grant us a license to use, display,
                  and distribute your content to enhance the user experience.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Termination</h2>
                <p className="body-base">
                  We may suspend or terminate your account if you violate these terms or engage in behavior that disrupts the
                  platform&apos;s integrity or user experience.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Limitation of liability</h2>
                <p className="body-base">
                  CampusGenie is not liable for any indirect, incidental, or consequential damages arising from your use of
                  the platform.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Governing law</h2>
                <p className="body-base">
                  These Terms and Conditions are governed by and construed in accordance with the laws of the jurisdiction
                  in which CampusGenie operates.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Changes to terms</h2>
                <p className="body-base">
                  We may modify these Terms and Conditions at any time. We will notify you of any changes by posting the
                  updated terms on our website or within the app.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Contact us</h2>
                <p className="body-base">
                  If you need support, download the CampusGenie app, then contact support or submit a ticket through the
                  app.
                </p>
              </section>
            </article>
          </Reveal>
        </div>
      </section>
    </>
  );
}
